var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCameraDisabledIconinline = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9236 23.1936C21.4617 24.0855 20.538 24.6907 19.4709 24.6907H7.95588C6.44284 24.6907 5.20056 23.4484 5.20056 21.9354V12.6182C5.21649 11.1052 6.44284 9.86292 7.95588 9.86292H8.59295L21.9236 23.1936Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2261 12.6182V20.5816L11.5074 9.86292H19.4708C20.9998 9.87884 22.2261 11.1052 22.2261 12.6182Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3856 11.3868C28.2264 11.4187 28.0671 11.4824 27.9237 11.578L24.0854 13.7918C23.7987 13.951 23.6235 14.2536 23.6235 14.5881V19.9236C23.6235 20.258 23.7987 20.5606 24.0854 20.7199L27.9556 22.9337C28.736 23.3956 29.7394 23.1407 30.2013 22.3603C30.2013 22.3444 30.2172 22.3444 30.2172 22.3285C30.3605 22.0737 30.4402 21.787 30.4402 21.5003V12.9795C30.4242 12.0558 29.6757 11.3231 28.7679 11.3391C28.6245 11.3391 28.4971 11.355 28.3856 11.3868Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2011 28.0511C23.8985 28.0511 23.6118 27.9237 23.3888 27.7167L3.89452 7.93571C3.44857 7.47383 3.44857 6.74121 3.89452 6.29526C4.34047 5.83338 5.0731 5.83338 5.51904 6.29526L25.0133 26.0762C25.4593 26.5381 25.4593 27.2707 25.0133 27.7167C24.7904 27.9397 24.5037 28.0511 24.2011 28.0511Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCameraDisabledIconinline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/camera-disabled-icon.inline.00b5662a73c716729b8db97c1b8faa8d.svg";